export default function Manual() {
    return (
        <div className="page-class">
            <h1>Anleitung</h1>
            <p>Um an unserer poetischen Rally teilnehmen zu können, musst Du dich als erstes mit E-Mail und Passwort registrieren. So verhindern wir unerlaubten Zugriff. Dann kann es losgehen:</p>
            <p>Findet die Poesie an Häuserwänden, an Denkmälern und Brunnen, in Sakralbauten oder in Schaufenstern,
                in Bedürfnisanstalten, flüchtig in Zu-verschenken-Kisten oder in der Bahn, verraucht in Kneipen oder
                an Orten, die wir uns noch gar nicht vorstellen können. Es kann ein Reim sein, ein Psalm oder nur ein großartiges Wort.</p>
            <p>Tragt Euren Fund unter <a href="/post">Poem melden</a> ein. Macht ein Foto von Eurer Sichtung, so dass man den Text gut lesen kann. Gebt die Adresse ein, wo sich Euer Gedicht befindet. Alternativ könnt Ihr den Standort von Eurem Handy ermitteln lassen. Aber Achtung: Das funktioniert nicht immer
                hundertprozentig &ndash; bitte überprüft daher die ermittelte Adresse. Schreibt uns noch ein paar Zeilen zu Eurer Sichtung. Und dann: Ab die Post!</p>
            <p>Einsendeschluss ist der 1. Mai 2025.</p>
            <br />
            <h3>Wir belohnen Ende Mai jeden Beitrag zum Faltplan mit einem kostenlosen Exemplar!</h3>
            <br/>
            <p>Wenn etwas nicht funktionieren sollte oder Ihr Fragen habt: Schreibt ein E-Mail
                an <a href="mailto:kontakt@poetica-westfalia.de">kontakt@poetica-westfalia.de</a></p>
        </div>
    )
}